exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img{max-width:50vw;max-height:300px}", ""]);

// exports
